import React from 'react';
import PropTypes from 'prop-types';
import InputWithButton from '../Common/InputWithButton/InputWithButton';
import './ResetPasswordForm.scss';

const ResetPasswordForm = ({ title, password, confirm, onSubmit, onChange, isTokenExpired, isOldPasswordRequired, oldPassword }) => {
	const passwordErrors = password.errors.join();
	const confirmErrors = confirm.errors.join();
	const oldPasswordErrors = oldPassword ? oldPassword.errors.join() : '';

	return (
		<div className='reset-password-container'>
			<div className='title'>{title}</div>
			{
				<form className='reset-password-form' onSubmit={onSubmit} noValidate>
					{isOldPasswordRequired ? (
						<div>
							<InputWithButton
								name='oldPassword'
								type='password'
								placeholder='Current Password'
								value={oldPassword.value}
								onChange={onChange}
								errorMessage={oldPasswordErrors}
								isFocused={true}
								isValid={passwordErrors.length <= 0}
								showButton={false}
							/>

							<InputWithButton
								name='password'
								type='password'
								placeholder='New Password'
								value={password.value}
								onChange={onChange}
								errorMessage={passwordErrors}
								isValid={passwordErrors.length <= 0}
								showButton={false}
							/>
						</div>
					) : (
						<InputWithButton
							name='password'
							type='password'
							placeholder='Password'
							value={password.value}
							onChange={onChange}
							errorMessage={passwordErrors}
							isFocused={true}
							isValid={passwordErrors.length <= 0}
							showButton={false}
						/>
					)}

					<InputWithButton
						name='confirm'
						type='password'
						placeholder='Confirm New Pasword'
						value={confirm.value}
						onChange={onChange}
						errorMessage={confirmErrors}
						isValid={confirmErrors.length <= 0}
						isDisabled={isTokenExpired}
						showButton={true}
						onButtonClick={onSubmit}
					/>

					<div className='text-left mt-3'>
						<strong>Password Complexity Rules:</strong>
						<div>Must be at least 7 characters with at least one number and special character</div>
						<div>Must not be all letters or all numbers</div>
						<div>Must not be related to your username</div>
						<div>Must not be one of the last four used passwords</div>
						<div>Must not be found in common password lists</div>
						<div>Must contain uppercase and lowercase letters</div>
					</div>
				</form>
			}
		</div>
	);
};

ResetPasswordForm.propTypes = {
	title: PropTypes.string.isRequired,
	password: PropTypes.object.isRequired,
	confirm: PropTypes.object.isRequired,
	onSubmit: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
	isTokenExpired: PropTypes.bool.isRequired,
	isOldPasswordRequired: PropTypes.bool,
	oldPassword: PropTypes.object,
};

export default ResetPasswordForm;
